var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEAD33",
    d: "M9.978 8.713h1.294v.231H9.978z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3835C1",
    d: "M8.645 10.543H9.9v.459H8.645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615EE8",
    d: "M9.9 10.543h.459v.459H9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3835C1",
    d: "M9.9 11.002h.459v.458H9.9zm.459.454h.459v.458h-.459zm.454.458h.459v.459h-.459zm.459.459h.458v.459h-.458zm.458.454h.459v.459h-.459zm.455.459h.458v.458h-.458zm.458.458h.459v.459h-.459zm.459.455h.458v.458h-.458zm.454.458h.459v.459h-.459zm.459.459h.458v.458h-.458zm.458.454h.459v.459h-.459zm.455.459h.458v.458h-.458zm.458.458h.459v.459h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615EE8",
    d: "M16.299 16.942h.459v.458h-.459zm.459.458h.458v.459h-.458zm-6.399-6.398h.459v.458h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615EE8",
    d: "M10.813 11.456h.459v.458h-.459zm.459.458h.458v.459h-.458zm.458.459h.459v.459h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615EE8",
    d: "M12.185 12.827h.458v.459h-.458zm.458.459h.459v.458h-.459zm.459.458h.458v.459h-.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615EE8",
    d: "M13.556 14.199h.459v.458h-.459zm.459.458h.458v.459h-.458zm.458.459h.459v.458h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615EE8",
    d: "M14.928 15.57h.458v.459h-.458zm.458.459h.459v.458h-.459zm.459.458h.458v.459h-.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3835C1",
    d: "M15.845 16.942h.458v.458h-.458zm.454.458h.459v.459h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7774F9",
    d: "M10.813 11.002h.459v.458h-.459zm.459.454h.458v.458h-.458zm.458.458h.459v.459h-.459zm.455.459h.458v.459h-.458zm.458.454h.459v.459h-.459zm.459.459h.458v.458h-.458zm.454.458h.459v.459h-.459zm.459.455h.458v.458h-.458zm.458.458h.459v.459h-.459zm.455.459h.458v.458h-.458zm.458.454h.459v.459h-.459zm.459.459h.458v.458h-.458zm.454.458h.459v.459h-.459zm.459.455h.458v.458h-.458zm.458.458h.459v.459h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615EE8",
    d: "M17.216 17.859h.459v.458h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3835C1",
    d: "M16.758 17.859h.458v.458h-.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7774F9",
    d: "M10.359 10.543h.459v.459h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C79F7",
    d: "M9.9 10.543V9.172h.459v1.371z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9B8EF",
    d: "M5.786 6.429h3.772V10.2H7.273v.343h1.372v.459H9.9v.454h-.115v-.343H8.529v-.454H7.158V10.2H5.786zm4.573 2.743h.111v1.255h.459v.575h-.116v-.459h-.454zm-.459 0h.57v-.116h-.454V7.684h-.458V7.8H9.9zm1.83 2.284v.458h.112v-.57h-.454v-.458h-.459v.116h.343v.454zm.455.917v-.459h-.343V11.8h.458v.458h.459v.459h.454v.454h.459v.574h-.116v-.458h-.454v-.459h-.459v-.454zm1.487 1.256h.458v.458h.455v.455h.458V15h.459v.57h-.116v-.454h-.458v-.459h-.455V14.2h-.458v-.455h-.343zm2.284 2.4v-.116h.459v.459h.458v.458h.455v.454h.458v.575h-.116V17.4h-.454v-.458h-.458v-.455h-.459v-.458zm-5.713-4.457h-.458v-.116h.574v.458h.454v.459h-.111v-.343h-.459zm1.029 1.255v-.454h-.57v.111h.454v.459h.459v.343h.115v-.459zm.801 1.029v-.454h-.458v-.116h.57v.458h.458v.455h-.115v-.343zm.913.458v.459h.459v.343h.111v-.459h-.454V14.2h-.574v.115zm1.029 1.256h.458v.459h-.115v-.343h-.459v-.459h-.454v-.111h.57zm.801.574v.455h.454v.343h.116v-.455h-.458v-.458h-.57v.115zm1.029.798h-.575v.115h.459v.459h.459v.343h.111V17.4h-.454zm.913 1.371v-.454h-.57v.111h.454v.459h1.144v-.57h-.116v.454zm-1.256-2.743h.343v.459h.111v-.57h-.454z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF1B5",
    d: "M8.529 11.229h.116v.115h-.116zm0-.116h.116v.116h-.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.47 9.63v.797h.459v.459h.459v.458h.685v-1.26h-.458V9.63zm-.685 1.483h-1.14v.801h.227v.228h.913v.917h-.112v.111h1.14v-.227h.343v-.459h-.454v-.454h-.459v-.458h-.458zm0 1.029h-.797v.342h.227v.343h.227v.232h.343zm2.173-.57h.115v.227h-.115z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED855",
    d: "M9.9 6.999h-.342v.458H9.9v-.115h.228v-.228H9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3925C",
    d: "M11.272 7.114h.227v.12h.116v.24h-.802v-.24h.459zm.441.36h-.57v.24h.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6C454",
    d: "M13.715 8.143h.428v.429h-.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED955",
    d: "M14.572 12H15v.857h-.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECE4D",
    d: "M6.472 10.427h.227v.232h-.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF5F",
    d: "M6.652 10.659h-.407v.227h.407zm.206.227h-.206v.227h.206zm-.206 0v.686h-.206v-.228h-.201v-.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEB63A",
    d: "M6.245 10.2v.459h.227v-.232h.227V10.2zm.685.227H6.7v.232h.231z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEAD33",
    d: "M8.302 10.77h-.116v.459h.227v.115h.116v-.458h-.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEDC6A",
    d: "M8.186 10.659v.111H7.96v.116h-.244v-.227zm0 0v.111h.116v.116h.227v-.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEB95",
    d: "M8.302 11.229h.116v.115h-.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED855",
    d: "M8.07 11.113h.116v.116h.116v.343h-.459v-.343h.227zm.232.801v-.342H8.07v.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3925C",
    d: "M7.715 12.716h.471v.454h.116v.232h-.459v-.232h-.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF5F",
    d: "M7.286 13.714h.429v.429h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEAE34",
    d: "M8.302 11.914H8.07v.828h.232v.115h.227v-.484h-.227zm.227.57h.343v.373h-.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEB95",
    d: "M8.645 11.344h-.343v1.029h.227v.111h.459v-.342h-.116v-.228h-.227v.228zm.57 1.14h-.343v.232h.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEDA5B",
    d: "M8.872 12.716v.141h.116v.202h.227v.111h.115v-.454zm.458 1.028h.343v.112H9.33zm.343.112h.343v.116h-.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA57",
    d: "M10.929 14.199h-.116v.343h.343v-.228h-.227zm.686.343h-.802v.115h.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEB95",
    d: "M10.813 13.513h.116v.116h-.116zm0 .116h.116v.115h.227v.112h-.343zm.232.227h-.232v.343h.116v-.227h.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEB95",
    d: "M11.615 12.943h-.802v.613h.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEAE34",
    d: "M10.929 13.513h.801v.116h-.801zm0 .116h.801v.115h-.115v.112h-.459v-.112h-.227zm.116.227h.454v.343h-.57v-.227h.116zm.111.458V14.2h-.227v.115zm.116-.115h.116v.115h-.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED855",
    d: "M11.143 13.714H12v.858h-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED855",
    d: "M11.615 13.402h.458v.227h-.343v-.116h-.115zm.458.227h-.343v.115h.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD955",
    d: "M10.813 13.856h-.454v.116h-.343v.227h.797zm0 .343h-.454v.115h.454z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEB95",
    d: "M9.442 12.827H9.33v.575h.099v.342h.244v.112h1.14v-.686h-1.14v.004v-.115h-.231zm.917 1.145v-.116H9.9v.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5D052",
    d: "M13.213 12.943h.343v.227h-.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD53",
    d: "M10.016 7.916h.459v.227h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEAE34",
    d: "M10.016 8.143h1.149v.583h-1.149z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEAD33",
    d: "M13.102 11.914v.159h-.686v-1.187h.797v1.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEAE34",
    d: "M11.958 8.944h.227v.116h-.227zm-.009-.231h.351v.231h-.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEAE34",
    d: "M11.73 8.713h.228v.227h-.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEAD33",
    d: "M10.47 8.944h.802v.116h-.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEAD33",
    d: "M10.929 9.056H12v.116h-1.07zm0 .116H12v.115h-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEE890",
    d: "M11.272 8.713h.343v.343h-.343zm.343 0h.115v.343h-.115z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED855",
    d: "M12.3 8.713h.116v.227H12.3zm.116 0h.227v.227h-.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEE890",
    d: "M11.73 8.944h.228v.116h-.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEB95",
    d: "M13.715 10.714h.428v.429h-.428zM12.3 12h.57v.257h-.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEB95",
    d: "M13.715 10.886h-.502v1.028h-.111V12h-.232v.257h.116v.116h.227v-.116h.232v-.227h.27zm-1.299-.116v.587h-.343v-.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED855",
    d: "M10.813 8.143h.917v.116h.228v.454h-.913v-.227h-.116v-.227h-.116zm1.145.116h.342v.227h.116v.227h-.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEB94",
    d: "M10.016 8.944h.459v.116h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEB94",
    d: "M12.759 8.944h-.574v.112h-.227v.231h-1.029v-.231h-.459v.574h1.145v.454h.458v.845h.686v-.502h.343v-1.14h-.343v.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.842 11.344h.231v.455h-.231z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C79F7",
    d: "M5.902 6.544h3.544v3.545H5.902z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9695F8",
    d: "M6.356 6.999H9.1v2.627H6.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C79F7",
    d: "M7.273 7.457h1.83v.459h-1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C79F7",
    d: "M9.099 7.569v1.144H8.64V7.569zm-1.83.347v1.371h-.454V7.916z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3835C1",
    d: "M6.356 9.283v.801h-.458v-.801zm1.256.806H6.356V9.63h1.256zm1.491 0h-.458V9.63h.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C79F7",
    d: "M8.186 9.172v.458H6.815v-.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615EE8",
    d: "M9.099 9.172v.458H8.64v-.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6FF",
    d: "M7.728 8.259h.458v.458h-.458zm.458.454H9.1v.459h-.913zm0 .459h.459v.458h-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615EE8",
    d: "M9.099 9.63H9.9v.913h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3835C1",
    d: "M7.273 10.084h1.83v.459h-1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C79F7",
    d: "M9.446 9.63V7.8h.459v1.83z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpell);
export default __webpack_public_path__ + "static/media/spell.1ad58c7690bd592ea7b76f05f78695e3.svg";
export { ForwardRef as ReactComponent };